import { IResponsePaging } from "../models/base";
import { IProduct } from "../models/productModel";
import { products } from "../repositories/";

export const checkInventory = async (pfs: any) => {
  const rs = await products.checkInventory(pfs);
  if (rs?.status == 200 && rs?.data) {
    return rs.data;
  }
  return {
    in_stock: true,
    message: "",
  };
};

const getProductInfoToCart = async (
  product_id: string,
  product_code: string,
  parent_pro_id: string,
  cat_id_v2: string = ""
) => {
  const rs = await products.productInfoToCart(
    product_id,
    product_code,
    parent_pro_id,
    cat_id_v2
  );
  if (rs && rs.data) {
    return rs.data;
  }
  return null;
};

export default {
  getProduct: async (query: any, callback: (data: any, err: any) => void) => {
    try {
      const rs = await products.getProduct(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  getRelatedProducts: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await products.getRelatedProducts(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  getBoughtTogetherProducts: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await products.getBoughtTogetherProducts(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  getProductPromotion: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await products.getProductPromotion(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  getProductInfoToCart,
  getProductsWish: async (
    query: any,
    callback: (data: IResponsePaging<IProduct[]>, err: any) => void
  ) => {
    try {
      const rs = await products.getProductsWish(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: IResponsePaging<IProduct[]> = null;
      callback(empty, error);
    }
  },
  getProductsWishV2: async (
    query: any,
    callback: (data: IResponsePaging<IProduct[]>, err: any) => void
  ) => {
    try {
      const rs = await products.getProductsWishV2(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: IResponsePaging<IProduct[]> = null;
      callback(empty, error);
    }
  },
  editProductWish: async (
    query: any,
    callback: (data: IResponsePaging<IProduct[]>, err: any) => void
  ) => {
    try {
      const rs = await products.editProductWish(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: IResponsePaging<IProduct[]> = null;
      callback(empty, error);
    }
  },
  editProductWishV2: async (
    query: any,
    callback: (data: IResponsePaging<IProduct[]>, err: any) => void
  ) => {
    try {
      const rs = await products.editProductWishV2(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: IResponsePaging<IProduct[]> = null;
      callback(empty, error);
    }
  },
  getProductsOfCategory: async (
    cat_id: string,
    offset: number,
    limit: number,
    callback: (data: IResponsePaging<IProduct[]>, err: any) => void
  ) => {
    try {
      const rs = await products.getProductsOfCategory({
        cat_id: cat_id,
        offset,
        limit,
      });
      callback(rs.data, null);
    } catch (error) {
      let empty: IResponsePaging<IProduct[]> = null;
      callback(empty, error);
    }
  },
  getProductsByCat: async (
    cat_id: string,
    offset: number,
    limit: number,
    sort: any,
    filter: any,
    path: any,
    callback: (data: IResponsePaging<IProduct[]> | null, err: any) => void
  ) => {
    try {
      const rs = await products.getProductsByCat(
        {
          offset,
          limit,
          sort,
          filter,
          path,
        },
        cat_id
      );
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  getProductsByCategory: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await products.getProductsByCategory(query);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  getCategoryOptions: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await products.getCategoryOptions(query);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  getProductSearch: async (
    offset: number,
    limit: number,
    textSearch: string,
    callback: (data: IResponsePaging<IProduct[]> | null, err: any) => void
  ) => {
    try {
      const rs = await products.getProductSearch({
        query: { offset, limit },
        data: { search: textSearch },
      });
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
};
